module.exports = __webpack_public_path__ + "img/h_tutorial_step-3.df36e4a2.png";